module.exports = __webpack_public_path__ + "static/media/middle-right-3.5d570bbf.png";